import React, { PropTypes } from 'react';
import { Button, Table, Modal, message} from 'antd';
import EditTeacherModal from './EditTeacherModal';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import UserRoleStore from '../../stores/UserRoleStore';
import {Link, hashHistory } from 'react-router';
import DataService from '../../lib/DataService';

import CurrentRoleActions from '../../actions/CurrentRoleActions';

const { Column, ColumnGroup } = Table;

export default class TeacherManagement extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      teachers: [],
      isEdit: false,
      showEditModal: false,
      role: CurrentRoleStore.getCurrentRole(),
      teacher: {},
      schoolId: props.params.schoolId,
    };
    // bind this
    this.editTeacher = this.editTeacher.bind(this);
    this.callbackEditTeacher = this.callbackEditTeacher.bind(this);
    this.goSetAdminPage = this.goSetAdminPage.bind(this);
  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onCurrentRoleChange);

    if (!this.state.role) {
      let schoolId = this.props.params.schoolId;
      let criteria = {schoolId : schoolId};
      CurrentRoleActions.findAndSetCurrentUserRole(criteria);
      this.setState({
        role: CurrentRoleStore.getCurrentRole()
      })
    }

    this.getAllTeachers();
  }

  getAllTeachers() {
    DataService.getAllTeachers({school_id: this.state.schoolId}).then((res) => {
      res.map((teacher) => {
        teacher.key = teacher.id;
        if (teacher.teaching_classes) {
          teacher.school_teaching_classes = [], teacher.other_teaching_classes = [];
          teacher.teaching_classes.map(record => {
            if (record.school_id == this.state.schoolId) {
              teacher.school_teaching_classes.push(record);
            } else {
              teacher.other_teaching_classes.push(record);
            }
          });

          teacher.join_class = teacher.school_teaching_classes.filter((record) => !record.is_graduated).map(record => {
            return record.name
          }).join(',');
        }
      })

      this.setState({
        teachers: res
      })
    })
  }

  componentWillUnmount(){
    CurrentRoleStore.removeChangeListener(this.onCurrentRoleChange);
  }

  editTeacher(record) {
    this.setState({
      isEdit: record ? true : false,
      teacher: record ? record : {},
      showEditModal: true,
    })
  }

  callbackEditTeacher(teacher) {
    this.setState({
      showEditModal: false
    })
    this.componentDidMount();
  }

  deleteTeacher(record) {
    Modal.confirm({
      title: '删除老师？',
      content: '确认要删除该老师吗？',
      okText: '确认删除',
      cancelText: '取消',
      onOk: () => {
        let data = {
          id: record.id,
          school_id: this.state.schoolId
        }
        DataService.deleteTeacher(data).then((res) => {
          message.success('删除成功');
          let index = this.state.teachers.findIndex((teacher) => teacher.id == record.id);
          this.state.teachers.splice(index, 1);
          this.setState({
            teachers: this.state.teachers
          })
        }, (response) => {
          // error response: {status: XXX, errorMessage: {errors: [{message: "Class not found", code: 41}]}}
        }).catch((error) => {
          // catch any error above block ('then' block)
          message.info('删除失败，请重试！');
        });
      },
      onCancel: () => {
        console.log('Cancel');
      },
    });
  }

  goSetAdminPage() {
    hashHistory.push(`school-admin/schools/${this.state.schoolId}/teacher-management/set-admin`);
  }

  _pageTitleView() {
    return (
      <div className="page-title">
        <span className="title">共{this.state.teachers.length}名老师</span>
        <Button icon="plus-circle" className="default-button" onClick={this.editTeacher.bind(this, null)}>添加老师</Button>
        <Button className="default-button" onClick={this.goSetAdminPage}>设置管理员</Button>
        {(this.state.role.associatName == 'school' || this.state.role.associatName == 'system') ? <Link className="import-teachers-btn" to={`school-admin/schools/${this.state.schoolId}/import-teachers`}>导入老师名单</Link> : ''}
      </div>
    )
  }

  _pageTableView() {
    return (
      <Table dataSource={this.state.teachers} className="page-table" pagination={false}>
        <Column
          dataIndex="avatar_url"
          key="avatar_url"
          render={(text, record) => (
            <div>
              {text ? <img src={ (!text.match('imageMogr2') && !text.match('imageView2')) ? (text + '?imageView2/1/w/150') : text } className="avatar"/> : <div className="avatar default-avatar"></div>}
            </div>
          )}
        />
        <Column
          title="姓名"
          dataIndex="full_name"
          key="full_name"
        />
        <Column
          title="手机号"
          dataIndex="mobile_phone"
          key="mobile_phone"
        />
        <Column
          title="班级"
          dataIndex="join_class"
          key="join_class"
        />
        <Column
          title="操作"
          key="action"
          render={(text, record) => (
            <span>
              <a onClick={this.editTeacher.bind(this, record)}>编辑</a>
              <span className="ant-divider" />
              <a onClick={this.deleteTeacher.bind(this, record)}>删除</a>
            </span>
          )}
        />
      </Table>
    )
  }

  render() {
    return (
      <div className="teacher-management-page">
        {this._pageTitleView()}
        {this._pageTableView()}
        <EditTeacherModal isEdit={this.state.isEdit} visible={this.state.showEditModal} teacher={this.state.teacher} role={this.state.role} schoolId={this.state.schoolId} callbackEditTeacher={this.callbackEditTeacher}/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/schooladmin/TeacherManagementPage.jsx